// extracted by mini-css-extract-plugin
export default {"balancesBlock":"balances-block_balancesBlock__KRL2A","customTabs":"balances-block_customTabs__AXZ1O"};